import {
    CREATE_UPLOAD_DOCUMENT_SUCCESS,
    CREATE_UPLOAD_DOCUMENT_ERROR,
    CREATE_UPLOAD_DOCUMENT_REQUEST,
    CREATE_LIST_DOCUMENT_SUCCESS,
    CREATE_LIST_DOCUMENT_ERROR,
    CREATE_LIST_DOCUMENT_REQUEST,
    EDIT_LIST_DOCUMENT_SUCCESS,
    EDIT_LIST_DOCUMENT_ERROR,
    EDIT_LIST_DOCUMENT_REQUEST,
    DELETE_LIST_DOCUMENT_SUCCESS,
    DELETE_LIST_DOCUMENT_ERROR,
    DELETE_LIST_DOCUMENT_REQUEST,
} from '../../Types/user/Types';

import {
    upload_DocumentsCreateApi,
    UploadDocuments_listAPI,
    edit_uploadDocumentLst,
    delete_uploadDocumentLst,
} from '../../Apis/user/ApiConfig';

export const create_upload_document_success = (res) => {
    return {
        type: CREATE_UPLOAD_DOCUMENT_SUCCESS,
        payload: res,
    };
};
export const create_Upload_document_error = (error) => {
    return {
        type: CREATE_UPLOAD_DOCUMENT_ERROR,
        error: error,
    };
};
export const create_upload_document_request = (res) => {
    return {
        type: CREATE_UPLOAD_DOCUMENT_REQUEST,
        payload: res,
    };
};

export const list_upload_document_success = (res) => {
    return {
        type: CREATE_LIST_DOCUMENT_SUCCESS,
        payload: res,
    };
};
export const list_Upload_document_error = (error) => {
    return {
        type: CREATE_LIST_DOCUMENT_ERROR,
        error: error,
    };
};
export const list_upload_document_request = (res) => {
    return {
        type: CREATE_LIST_DOCUMENT_REQUEST,
        payload: res,
    };
};

export const edit_upload_document_success = (res) => {
    return {
        type: EDIT_LIST_DOCUMENT_SUCCESS,
        payload: res,
    };
};
export const edit_Upload_document_error = (error) => {
    return {
        type: EDIT_LIST_DOCUMENT_ERROR,
        error: error,
    };
};
export const edit_upload_document_request = (res) => {
    return {
        type: EDIT_LIST_DOCUMENT_REQUEST,
        payload: res,
    };
};

export const delete_upload_document_success = (res) => {
    return {
        type: DELETE_LIST_DOCUMENT_SUCCESS,
        payload: res,
    };
};
export const delete_Upload_document_error = (error) => {
    return {
        type: DELETE_LIST_DOCUMENT_ERROR,
        error: error,
    };
};
export const delete_upload_document_request = (res) => {
    return {
        type: DELETE_LIST_DOCUMENT_REQUEST,
        payload: res,
    };
};

export const create_upload_document_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(create_upload_document_request());
        try {
            upload_DocumentsCreateApi(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(create_upload_document_success(res?.data));
                            // dispatch(create_edit_faq_ques_list_actionHandler())
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(create_Upload_document_error(res));
                        }
                    } else {
                        dispatch(create_Upload_document_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_Upload_document_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(create_Upload_document_error(err));
        }
    };
};

export const list_upload_document_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(list_upload_document_request());
        try {
            UploadDocuments_listAPI()
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(list_upload_document_success(res?.data));
                            // dispatch(create_upload_document_actionHandler())
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(list_Upload_document_error(res));
                        }
                    } else {
                        dispatch(list_Upload_document_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        list_Upload_document_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(list_Upload_document_error(err));
        }
    };
};

export const edit_upload_document_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(edit_upload_document_request(data));
        try {
            edit_uploadDocumentLst(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(edit_upload_document_success(res?.data));
                            dispatch(list_upload_document_actionHandler());
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(edit_Upload_document_error(res));
                        }
                    } else {
                        dispatch(edit_Upload_document_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        edit_Upload_document_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(edit_Upload_document_error(err));
        }
    };
};

export const delete_upload_document_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(delete_upload_document_request(data));
        try {
            delete_uploadDocumentLst(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(delete_upload_document_success(res?.data));
                            dispatch(list_upload_document_actionHandler());
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(delete_Upload_document_error(res));
                        }
                    } else {
                        dispatch(delete_Upload_document_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        delete_Upload_document_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(delete_Upload_document_error(err));
        }
    };
};
